import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { isBrowser } from 'utils/browser';

import Button from 'components/layout/Button';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    job,
    buttonProps,
    title,
}) => {
    const router = useRouter();
    // const baseUrl = isBrowser() && router.query?.baseUrl ? window.atob(router.query.baseUrl.toString()) : null;

    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-header"
        >
            {job?.endAtDisplay && !job.isClosed && (
                <>
                    {/*
                    <Button
                        {...buttonProps}
                        onClick={() => router.push(baseUrl || Routes.PublicJobs)}
                    /> */}

                    <div
                        className="title"
                        dangerouslySetInnerHTML={{ __html: `${title} ${job?.endAtDisplay} (${job?.endAtDiff} dni)` }}
                    />
                </>
            )}
            {job?.isClosed && (
                <div className="title title-closed">
                    <p> Oferta archiwalna</p>
                </div>
            )}

        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;